import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import Div from '@jumbo/shared/Div'
import reportDataServices from 'app/services/pages/reports/report-data-services'
import { getTransactionListReport } from 'app/redux/store/features/reports'
import PaymentListReportLayout from './PaymentListReportLayout'

const PaymentListReport = () => {
    const dispatch = useDispatch()
    const itemsPerPage = 25
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const [imageData, setImageData] = useState('')
    const [pdfData, setPdfData] = useState({})
    const { enqueueSnackbar } = useSnackbar()
    const navigate = useNavigate()

    const [reportFilter, setReportFilter] = useState({
        customerId: null,
        termId: null,
        classId: null,
        sort: '',
        hasBalance: false,
    })

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const applyViewFilter = useMutation({
        mutationFn: async (viewFilter) => {
            const filter = { ...viewFilter, skip: 0, take: itemsPerPage }
            setReportFilter(filter)
            dispatch(getTransactionListReport(filter))
        },
    })

    const applyPageChange = useMutation({
        mutationFn: async (page) => {
            const filter = { ...reportFilter, skip: (page - 1) * itemsPerPage, take: itemsPerPage }
            setReportFilter(filter)
            dispatch(getTransactionListReport(filter))
        },
    })

    const applyPdfFilter = useMutation({
        mutationFn: async () => {
            const filter = { ...reportFilter, skip: 0, take: 2000 }
            const data = await fetchData(filter)
            setPdfData(data)
            return data
        },
    })

    const fetchData = useCallback(async (filter) => {
        const reportData = await reportDataServices.getPaymentListReportData(filter, handleError)
        return reportData
    }, [])

    useEffect(async () => {
        setApiCallInProgress(true)
        const image = await reportDataServices.getImage()
        const imageData = image.data ? image.data : ''
        setImageData(imageData)
        dispatch(getTransactionListReport({ ...reportFilter, skip: 0, take: itemsPerPage }))
    }, [dispatch])

    return (
        <Div>
            <PaymentListReportLayout
                imageData={imageData}
                viewMutation={applyViewFilter}
                pdfMutation={applyPdfFilter}
                pageMutation={applyPageChange}
                apiCallInProgress={apiCallInProgress}
                setApiCallInProgress={setApiCallInProgress}
                pdfData={pdfData}
            />
        </Div>
    )
}

export default PaymentListReport
